import { GENERIC_ERROR_KEY } from "./../../../Constants/Defaults";
import { AppThunk } from "./../../Store";
import { Api, LogService } from "../../../Services";
import { Actions } from "./ContactUsSlice";
import { ContactUsRequest } from "../../../Models/ServerModels/ContactUs/ContactUsRequest";

export const sendContactUsLead =
    (contactUsRequestBody: ContactUsRequest): AppThunk =>
    async (dispatch: any) => {
        try {
            await dispatch(Actions.setContactUsProgress());
            const response = await Api.ContactUs.sendContactUs(contactUsRequestBody);
            if (response && response.statusCode === 200 && response.data) {
                await dispatch(Actions.setContactUsCompleted());
            } else {
                await dispatch(Actions.setContactUsFailed(response?.error || GENERIC_ERROR_KEY));
            }
        } catch (ex) {
            LogService.logError(`Exception occurred in sendContactUs: ${ex}`);
            await dispatch(Actions.setContactUsFailed(GENERIC_ERROR_KEY));
        }
    };
